module.exports = __webpack_public_path__ + "static/media/logo.c4b6cf5a.svg";